import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {finalize, timeout} from "rxjs/operators";
import {Inject, Injectable, Injector, PLATFORM_ID} from "@angular/core";
import {environment} from "@biletix/env";
import {I18nService} from "@biletix/core/services/i18n.service";
import {LoadingScreenService} from "@biletix/core/components/loading/loading-screen.service";
import {ChannelService} from "@biletix/core/services/channel.service";
import { CustomerTokenService } from "../services/token.service";
import {isPlatformServer} from "@angular/common";


@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {

  private static readonly SSR_REQUEST_TIMEOUT_MS = 15000;

  constructor(private readonly injector: Injector,
              @Inject(PLATFORM_ID) private platformId: Object) {

  }


  private get loadingService() {
    return this.injector.get(LoadingScreenService);
  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const i18n = this.injector.get<I18nService>(I18nService);
    const channelService = this.injector.get<ChannelService>(ChannelService);
    const customerTokenService = this.injector.get<CustomerTokenService>(CustomerTokenService);

    let modifiedRequest = req.clone({
        setHeaders: {
          CHANNEL: channelService.getChannel(),
          'Accept-Language': i18n.currentLang,
          CPU: environment.CPU + "",
          CLIENT_APP_ENVIRONMENT:environment.PROFILE,
        },
      withCredentials: isPlatformServer(this.platformId) ? false : environment.SEND_COOKIES
      }
    );

    const customerToken = customerTokenService.getToken();
    if(customerToken){
      modifiedRequest = modifiedRequest.clone({
        setHeaders: {
          CUSTOMERTOKEN: customerToken
        },
      });
    }

    const appVersion = customerTokenService.getAppVersion();
    if(appVersion){
      modifiedRequest = modifiedRequest.clone({
        setHeaders: {
          APPVERSION: appVersion
        },
      });
    }


    //Dil dosyaları yüklenirken loading component gösterme
    let url = modifiedRequest.url;

    console.log("Requesting " + url);
    modifiedRequest = modifiedRequest.clone({ url });

    let isAssetsFile = !!url && url.includes('assets/i18n/');
    const isIsmApi:boolean = !!url && (url.includes('/api/v1/seatPlans/hold')|| url.includes('/api/v1/seatPlans/release')|| url.includes('/api/v1/seatPlans/getAllBlockSeats'));
    const isSearchSuggestion: boolean = !!url && (url.includes('/api/v1/searchquery/searchSuggestion/') || url.includes('qt=autocomplete'));
    const skipLoading = isAssetsFile || isIsmApi || isSearchSuggestion;

    if (!skipLoading)
      this.loadingService.open();


    let response$ = next.handle(modifiedRequest);

    // SSR'da render ve kullandığı bellek, en yavaş API çağrısı bitene kadar yaşar. Süre sınırı
    // olmadan (fetch varsayılanı 300 sn) API yavaşladığında render'lar worker'da birikiyordu.
    // Zaman aşımı ağ hatasıyla aynı şekilde (status 0) bildirilir; resolver'lar bunu zaten
    // geçici hata olarak ele alıyor. Abonelik bırakılınca fetch de iptal edilir.
    if (isPlatformServer(this.platformId)) {
      response$ = response$.pipe(
        timeout({
          each: CustomHttpInterceptor.SSR_REQUEST_TIMEOUT_MS,
          with: () => {
            console.error(`SSR request timed out after ${CustomHttpInterceptor.SSR_REQUEST_TIMEOUT_MS} ms: ${url}`);
            return throwError(() => new HttpErrorResponse({url, status: 0, statusText: 'SSR request timeout'}));
          }
        })
      );
    }

    return response$
      .pipe(
        finalize(() => {
          if (!skipLoading)
            this.loadingService.close();
        })
      );
  }
}
